<template>
  <!-- Need to add height inherit because Vue 2 don't support multiple root ele -->
  <div class="chat-application" style="height: inherit">
    <div
      class="body-content-overlay"
      :class="{'show': shallShowUserProfileSidebar ||  mqShallShowLeftSidebar}"
      @click="mqShallShowLeftSidebar=shallShowUserProfileSidebar=false"
    />

    <!-- Main Area -->
    <section class="chat-app-window">


      <!-- Start Chat Logo -->
      <div v-if="!activeSession" class="start-chat-area">
        <div v-if="loadingSession">
          <b-spinner variant="primary" type="grow" class="spinner-lg"/>
        </div>
        <div class="mb-1 start-chat-icon" v-if="!loadingSession">
          <feather-icon icon="MessageSquareIcon" size="56"/>
        </div>
        <h4 v-if="!loadingSession" class="sidebar-toggle start-chat-text" @click="startConversation">
          Start Conversation
        </h4>
      </div>

      <!-- Chat Content -->
      <div v-else class="active-chat">
        <!-- Chat Navbar -->
        <div class="chat-navbar">
          <header class="chat-header">

            <!-- Avatar & Name -->
            <div class="d-flex align-items-center" @click="openClient">

              <!-- Toggle Icon -->
              <div class="sidebar-toggle d-block d-lg-none mr-1">
                <feather-icon icon="MenuIcon" class="cursor-pointer" size="21" @click="mqShallShowLeftSidebar = true"/>
              </div>

              <b-avatar size="36" :src="activeSession.avatar" class="mr-1 cursor-pointer badge-minimal"/>
<!--                badge
                :badge-variant="resolveAvatarBadgeVariant(activeSession.status)"
              />-->
              <h6 class="mb-0 text-capitalize">
                {{ activeSession.sessionName }}
              </h6>
            </div>

            <!-- Contact Actions -->
            <div class="d-flex align-items-center">
            <feather-icon
                icon="LogOutIcon"
                size="17"
                class="cursor-pointer d-sm-block d-none mr-1"
                @click="tryFinalizeSession"
              />
<!--              <feather-icon
                icon="VideoIcon"
                size="17"
                class="cursor-pointer d-sm-block d-none mr-1"
              />
              <feather-icon
                icon="SearchIcon"
                size="17"
                class="cursor-pointer d-sm-block d-none mr-50"
              />-->
<!--              <div class="dropdown">
                <b-dropdown variant="link" no-caret toggle-class="p-0" right>
                  <template #button-content>
                    <feather-icon icon="MoreVerticalIcon" size="17" class="align-middle text-body"/>
                  </template>
                  <b-dropdown-item>View Contact</b-dropdown-item>
                  <b-dropdown-item>Mute Notifications</b-dropdown-item>
                  <b-dropdown-item>Block Contact</b-dropdown-item>
                  <b-dropdown-item>Clear Chat</b-dropdown-item>
                  <b-dropdown-item>Report</b-dropdown-item>
                </b-dropdown>
              </div>-->
            </div>
          </header>
        </div>

        <!-- User Chat Area -->
        <vue-perfect-scrollbar ref="refChatLogPS" :settings="perfectScrollbarSettings" class="user-chats scroll-area">
          <chat-log v-bind:busy="loadingSession"
             v-bind:no-avatar="disableAvatar"
            :session="activeSession"
            :profile-user-avatar="profileUserDataMinimal.avatar"
             @loaded="scrollToBottomInChatLog"
          />
        </vue-perfect-scrollbar>

        <!-- Message Input -->
        <chat-input @message-sent="scrollToBottomInChatLog"/>
      </div>
    </section>


    <!-- Sidebar -->
    <portal to="content-renderer-sidebar-left">
      <chat-left-sidebar
          ref="chat-left-sidebar"
          :no-avatar="disableAvatar"
          :sessions="sessions"
          :contacts="contacts"
          :active-chat-contact-id="activeSession  ? activeSession.id : null"
          :shall-show-user-profile-sidebar.sync="shallShowUserProfileSidebar"
          :profile-user-data="profileUserData"
          :profile-user-minimal-data="profileUserDataMinimal"
          :mq-shall-show-left-sidebar.sync="mqShallShowLeftSidebar"
          @show-user-profile="showUserProfileSidebar"
          @open-chat="openChatOfContact"
      />
    </portal>
  </div>
</template>

<script>
import store from '@/store'
import { ref, onUnmounted, nextTick, } from '@vue/composition-api'
import {
  BAvatar, BDropdown, BDropdownItem, BForm, BInputGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { $themeBreakpoints } from '@themeConfig'
import ChatLeftSidebar from './ChatLeftSidebar.vue'
import ChatActiveChatContentDetailsSidedbar from './ChatActiveChatContentDetailsSidedbar.vue'
import ChatLog from './ChatLog.vue'
import useChat from './useChat'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ChatInput from '@/views/chat/ChatInput.vue'
import mixinBase from '@/components/mixin/mixinBase'

export default {
  mixins:[mixinBase],
  components: {
    ChatInput,
    /* BSV */ BAvatar, BDropdown, BDropdownItem, BForm, BInputGroup, BFormInput, BButton,/* 3rd Party */ VuePerfectScrollbar,/* SFC */ ChatLeftSidebar, ChatActiveChatContentDetailsSidedbar, ChatLog, },
  data: () => ({
    loadingSession: false, // Will be used to show loading spinner in start chat area
    disableAvatar: false, // Will be used to disable avatar badge
    // Shall Show User Profile Sidebar
    resolveAvatarBadgeVariant: useChat().resolveAvatarBadgeVariant,
    //Chats & Contacts
    contacts: [],
    //Single Chat
    perfectScrollbarSettings: { maxScrollbarLength: 150, },
    // User Profile Sidebar
    // ? Will contain all details of profile user (e.g. settings, about etc.)
    profileUserData: {},
    shallShowUserProfileSidebar: false,
    // UI + SM Devices
    // Left Sidebar Responsiveness
    mqShallShowLeftSidebar: false, //useResponsiveAppLeftSidebarVisibility().mqShallShowLeftSidebar,
    fetchChatAndContactsIntervalId: null,
  }),
  created() {
    // Fetch Chats & Contacts
    this.init()
    this.$on('system::chat::messages::updated', this.scrollToBottomInChatLogOnUserMessage)
    this.fetchChatAndContactsIntervalId = setInterval(() => this.fetchChatAndContacts(), 60000); // Refresh every 60 seconds
  },
  beforeDestroy() {
    this.$off('system::chat::messages::updated', this.scrollToBottomInChatLogOnUserMessage)
    clearInterval(this.fetchChatAndContactsIntervalId);
  },
  computed:{
    ...mapGetters("user", ["user"]),
    ...mapGetters("chat", ["sessions", "activeSession", "chatBySessionId"]),
    profileUserDataMinimal() {
      let user = this.user || {}
      return {
        id: user.id,
        avatar: user.avatar || '1',
        fullName: user.fullName,
        status: user.status,
      }
    },
  },
  methods:{
    ...mapActions("chat", ["fetchChatSessions", "fetchChatSession", "sendChatMessage", 'initChatSession', "finalizeSession"]),
    ...mapMutations("chat", ["setActiveChat"]),
    ...mapActions("chat", {_getChat:"getChat",_sendMessage:"sendMessage",_getProfileUser:"getProfileUser"}),
    init(){
      this.fetchChatAndContacts()
    },
    // ------------------------------------------------
    // Chats & Contacts
    // ------------------------------------------------
    scrollToBottomInChatLogOnUserMessage(sessionId) {
      console.log('scrollToBottomInChatLogOnUserMessage called with sessionId:', sessionId)
      if(this.activeSession == null || sessionId !== this.activeSession?.id) {
        console.warn('Active session does not match the sessionId:', sessionId)
        return
      }
      let lastMessage = this.chatBySessionId[sessionId]?.messages?.slice(-1)[0]
      if(!lastMessage) {
        console.warn('No last message found for session:', sessionId)
        return
      }
      if (lastMessage.senderId === this.user.id) {
       setTimeout(this.scrollToBottomInChatLog, 1000) // Delay to ensure the new message is rendered
      }
    },
    scrollToBottomInChatLog() {
      console.log('scrollToBottomInChatLog called')
      const refChatLogPS = this.$refs.refChatLogPS
      if(!refChatLogPS) {
        console.warn('refChatLogPS is not defined')
        return
      }
      const scrollEl = refChatLogPS.$el || refChatLogPS
      scrollEl.scrollTop = scrollEl.scrollHeight + 100 // Add some extra space to ensure the last message is visible
    },
    fetchChatAndContacts() {
      let $this = this
      if (($this.queryParams().session != null && $this.queryParams().session !== '' )|| ($this.queryParams().sessionClientId != null && this.queryParams().sessionClientId !== '')) {
        $this.setActiveChat(null);
        $this.loadingSession = true;
      }
      this.fetchChatSessions()
          .then(response => {
            if ($this.queryParams().session != null && $this.queryParams().session !== '') {
              $this.openChatOfContact($this.queryParams().session)
              $this.loadingSession = false;
            } else if ($this.queryParams().sessionClientId != null && this.queryParams().sessionClientId !== '') {
              $this.openChatOfContactByClientId($this.queryParams().sessionClientId)
            }
            $this.$refs['chat-left-sidebar']?.setLoading(false)
          })
    },
    // ------------------------------------------------
    // Single Chat
    // ------------------------------------------------
    openChatOfContactByClientId(clientId) {
      let $this = this
      let session = this.sessions.find(s => s.clientId === clientId)
      if (session != null) {
        this.openChatOfContact(session.id)
      }else {
        this.loadingSession = true
        this.initChatSession(clientId).finally(()=>$this.loadingSession = false)
      }
    },
    openChatOfContact(sessionId) {
      let $this = this
      // Reset send message input value
      this.chatInputMessage = ''
      this.loadingSession = this.activeSession == null || this.activeSession.id !== sessionId
      this.setActiveChat(sessionId);
      this.pushState({
        session: sessionId,
        sessionClientId: this.activeSession.clientId
      })
      this.fetchChatSession(sessionId).then(session=>{
        this.setActiveChat(sessionId);
        //TODO: Set read (unseenMsgs=0) for active chat
        // Scroll to bottom
        nextTick(() => { $this.scrollToBottomInChatLog() })
        // if SM device =>  Close Chat & Contacts left sidebar
        // eslint-disable-next-line no-use-before-define
        $this.mqShallShowLeftSidebar = false
      }).finally(() => {
        $this.loadingSession = false
      })
    },

    showUserProfileSidebar() {
      let $this = this
      //TODO: Uncomment for get and show profile user data sidebar
      /*this._getProfileUser()
          .then(response => {
            $this.profileUserData = response.data
            $this.shallShowUserProfileSidebar = true
          })*/
    },
    startConversation() {
      if (store.state.app.windowWidth < $themeBreakpoints.lg) {
        this.mqShallShowLeftSidebar = true
      }
    },

    openClient() {
      if (this.activeSession == null || this.activeSession.clientId == null) {
        return
      }
      this.showClient(this.activeSession.clientId)
    },
    tryFinalizeSession(){
      let $this = this
      this.$bvModal.msgBoxConfirm(this.$t('chat.messages.finalizeSessionQuestion'), {
        title: this.$t('chat.messages.finalizeSession'),
        size: 'sm', buttonSize: 'sm', okVariant: 'danger',
        okTitle: this.$t('operations.yes'), cancelTitle: this.$t('operations.no'),
        hideHeaderClose: false, centered: true
      }).then(value => {
            if(!value) return
            $this.finalizeSession(this.activeSession.clientId)
            $this.fetchChatSessions()
            $this.pushState({ session: null, sessionClientId: null});
          })
      console.log("tryFinalizeSession",this.activeSession.clientId)
      // this.finalizeSession(this.activeSession.clientId)
    }
  },

}
</script>

<style lang="scss" scoped>

</style>

